<script lang="ts">
    import { t } from "@lernetz/svelte-translate";
    import { createEventDispatcher, onMount } from "svelte";
    import { createModelApi, setModelApiContext, type ModelApiType } from "@lernetz/svelte-model-api";
    import { requests, setupSharedProps } from "../../../setup";
    import { router } from '@inertiajs/svelte'
    //import { modelApi } from "../../../services";

    export let formData;


    let emailRepeat = "";

    let modelApi: any;

    const dispatch = createEventDispatcher();

    const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    $: isValid =
        emailPattern.test(formData.email?.trim() ?? "") &&
        formData.email?.trim() === emailRepeat.trim();



    function create() {
        router.post('/createDashboard', formData)
    }

</script>

<div class="bg-white w-full max-w-580 p-24 md:p-48 rounded-3xl md:min-h-[672px] flex flex-col max-h-[calc(100dvh-6rem)] md:max-h-[calc(100dvh-3rem)] overflow-y-auto">
    <div class="text-28 font-bold text-center">
        {$t('create dashboard')}
    </div>
    <div class="text-18 mt-32">
        {$t('Add your email address. You will receive access to your dashboard via email and can access it at any time via the link.')}
    </div>
    <div class="mt-16">
        <div class="flex flex-col grow">
            <label for="email" class="size-14 text-grey-1 w-full">
              {$t('email address')}
            </label>
            <input id="name" type="email" placeholder="E-Mail" bind:value={formData.email} class="mt-10 border-blue-light border-2 rounded-lg text-18 px-16 py-8"/>
        </div>
        <div class="flex flex-col grow mt-20">
            <label for="email" class="size-14 text-grey-1 w-full">
              {$t('repeat email address')}
            </label>
            <input id="name" type="email" placeholder="E-Mail" bind:value={emailRepeat} class="mt-10 border-blue-light border-2 rounded-lg text-18 px-16 py-8"/>
        </div>
    </div>
    <div class="mt-32 md:mt-auto flex justify-between items-center">
        <button on:click={() => dispatch('back')} class="border-blue-main border-2 text-blue-main px-24 py-10 rounded-md w-fit font-bold">{$t('back')}</button>
        <span class="text-18 font-bold text-grey-1">3/3</span>
        <button disabled={!isValid} on:click={create} class="{!isValid ? 'bg-blue-light' : 'bg-blue-main'} px-24 py-10 rounded-md text-white w-fit">{$t('create dashboard')}</button>
    </div>
</div>
